export default "__VITE_ASSET__qcK928Nt__"